import { useAuthContext } from '@/context/AuthContext.tsx';
import { useOwnerGymProfile } from '@/hooks/useGetOwnerGymProfile';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const IsLoggedIn: FC = () => {
  const { isLoading, user, session } = useAuthContext();
  const location = useLocation();
  const { data: gymProfile, isLoading: isLoadingGym } = useOwnerGymProfile(user?.id ?? '');
  const OWNER_DASHBOARD_ROOT = '/owner-dashboard';
  if (isLoading || isLoadingGym) {
    return <Middleware isLoading />;
  }

  if (!session) {
    return <Navigate to={Routes.LOGIN} replace />;
  }
  if (!user) {
    return <Navigate to={Routes.CALLBACK_AUTH} replace />;
  }
  if (user.email_verified === false || !user.email_verified) {
    return <Navigate to={Routes.CONFIRM_EMAIL} replace />;
  }

  const isOwner = user?.role === 'owner';
  const isGoer = user?.role === 'goer';
  if (isOwner) {
    if (!gymProfile) {
      if (location.pathname !== Routes.OWNER_ONBOARDING) {
        return <Navigate to={Routes.OWNER_ONBOARDING} replace />;
      }
    } else {
      const status = gymProfile.status;
      const isInOwnerDashboard = location.pathname.startsWith(OWNER_DASHBOARD_ROOT);
      const isPendingCreation = status === 'pending_creation';
      if (isPendingCreation) {
        const isOnConfirmation = location.pathname === Routes.ASSISTED_LISTING_CONFIRMATION;
        const isOnOwnerDashboard = location.pathname.startsWith(OWNER_DASHBOARD_ROOT);
        if (!isOnConfirmation && !isOnOwnerDashboard) {
          return <Navigate to={Routes.ASSISTED_LISTING_CONFIRMATION} replace />;
        }
      } else if (!status) {
        if (location.pathname !== Routes.SUBSCRIPTION) {
          return <Navigate to={Routes.SUBSCRIPTION} replace />;
        }
      } else if (status) {
        if (!isInOwnerDashboard) {
          return <Navigate to={Routes.OWNER_LISTING_STATUS} replace />;
        }
      }
    }
  }
  if (isGoer) {
    return <Outlet />;
  }

  return <Outlet />;
};
export default IsLoggedIn;
